<template>
    <div class="scanner">
        <div class="row">
            <p v-if="debug">{{ browser }}</p>
            <!-- ios 顯示以下 -->
            <div class="col-lg-12 tips-iphone" v-if="safari">
                <ul>

                    <li>請點選右上角<img src="img/parkit/tips_ios_share.png" alt="" />圖示。</li>
                    <li>再點選<span>【使用 Sarfari 瀏覽】</span>開啟網頁。</li>
                    <li><span>【允許】</span>取用相機，即可掃描 QR Code。</li>

                </ul>
            </div>
            <!-- ios 顯示以上 -->

            <!-- android 顯示以下 -->
            <div class="col-lg-12 tips-android" v-if="android">
                <ul>

                    <li>請點選右上角<img src="img/parkit/tips_ios_share.png" alt="" />圖示。</li>
                    <li>再點選<span>【使用 Chrome 瀏覽】</span>開啟網頁。</li>
                    <li><span>【允許】</span>取用相機，即可掃描 QR Code。</li>

                </ul>
            </div>
            <!-- android 顯示以上 -->

            <div class="col-lg-12 text-center scanner-box" v-if="!safari && !android && !showScanResult">
                <span>請您將 QR Code 對準畫面即可掃描</span>
            </div>
        </div>
        <!--
        <qrcode-stream class="qrcode" v-if="!safari && !android && !showScanResult" @decode="onDecode" @init="onInit">
            <transition name="fade">
                <div style="text-align: center; margin-top: 12px; text-shadow: 2px 2px #434a54;" class="text-warning" v-if="scan_hint">
                    {{ scan_hint }}
                </div>
            </transition>

            <div class="qr-top-left"></div>
            <div class="qr-top-right"></div>
            <div class="qr-bottom-left"></div>
            <div class="qr-bottom-right"></div>
        </qrcode-stream>
        -->
        <div id="scandit-barcode-picker" v-if="!safari && !android" class="qrcode"></div>


        <div class="plate-modal modal fade" id="invoice-success-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
                    <div class="lr">
                    <div class="rl"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                    <div class="col-lg-8 mx-auto">
                        <div class="modal-body">
                        <!-- Project Details Go Here -->
                        <h3 class="">發票登錄成功</h3>
                        <p class="item-intro text-muted">
                            發票號碼： {{ invoice_number }} <br>
                            {{ discount_description }}
                        </p>
                        <p>
                            目前已折抵發票：
                            <ul style="text-align:left">
                                <li v-for="record in invoice_records" :key="record.receipt_number">
                                    {{ record.receipt_number }} ${{ record.amount }}
                                </li>
                            </ul>
                        </p>
                        <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button" v-on:click="showPayView()">
                            折抵紀錄
                        </button>
                        <button class="btn btn-primary btn-green" data-dismiss="modal" type="button" v-on:click="keepScan()">
                            繼續掃描
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- modal-content ends -->
            </div><!-- modal-dialog ends -->
        </div>

      <div class="plate-modal modal fade" id="invoice-error-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <h3 class="text-danger">發票登錄失敗</h3>
                    <p class="item-intro text-muted">
                        發票號碼： {{ invoice_number }} <br>
                        僅供當日發票折抵停車
                    </p>
                    <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button" v-on:click="showPayView()">
                        折抵紀錄
                    </button>
                    <button class="btn btn-primary btn-green" data-dismiss="modal" type="button" v-on:click="keepScan()">
                        繼續掃描
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- modal-content ends -->
        </div><!-- modal-dialog ends -->
      </div>
      <!-- plate-delete-modal ends -->

        <div class="plate-modal modal fade" id="invoice-already-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <h3 class="text-danger">發票已使用</h3>
                    <p class="item-intro text-muted">
                        發票號碼： {{ invoice_number }} <br>
                        此發票已登錄過
                    </p>
                    <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button" v-on:click="showPayView()">
                        折抵紀錄
                    </button>
                    <button class="btn btn-primary btn-green" data-dismiss="modal" type="button" v-on:click="keepScan()">
                        繼續掃描
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- modal-content ends -->
        </div><!-- modal-dialog ends -->
      </div>
      <!-- plate-delete-modal ends -->

    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import * as ScanditSDK from "scandit-sdk";
import { decode } from 'punycode';

export default {
  name: 'ScannerView',
  props: ['plate', 'lot_code'],
  components: {
    QrcodeStream,
  },
  data() {
    return {
      error: "",
      browser: "",
      safari: false,
      android: false,
      debug: false,
      showScanResult: false,
      recording: false,
      discount_description: "",
      invoice_number: "",
      scan_hint: "",
      invoice_records: [],
      brand_code: ""
    }
  },
  mounted() {
    var self = this
    self.browser = navigator.userAgent
    self.brand_code = process.env.VUE_APP_BRAND
    self.initScanner()
  },
  methods: {
    onDecode (decodedString) {
        var self = this
        console.log(decodedString)
        console.log("qr code length: " + decodedString.length)
        if (decodedString.length >= 77 && !self.recording) {
            console.log("get left side")
            var invoice_number = decodedString.substring(0, 10) //發票字軌
            var coupon = false
            const invoice_date = decodedString.substring(10, 17) //發票開立日期
            const invoice_random = decodedString.substring(17, 21) //隨機碼
            const invoice_sell_price = parseInt(decodedString.substring(21, 29), 16).toString(10) //銷售額
            const invoice_total_sell_price = parseInt(decodedString.substring(29, 37), 16).toString(10) //總計額
            const invoice_buy_tax_number = decodedString.substring(37, 45) //買方統編
            const invoice_sell_tax_number = decodedString.substring(45, 53) //賣方統編
            const invoice_aes_encode = decodedString.substring(53, 77) // 24 加密欄位
            const pos_info = decodedString.substring(78, 100)
            var credit_card = false
            if (decodedString.length >= 78) {
                credit_card = decodedString.substring(77,78)
                if (credit_card == 1) {
                    credit_card = true
                } else {
                    credit_card = false
                }
            }

            var member_card = false
            if (process.env.VUE_APP_BRAND == 'ikea') {
                member_card = invoice_aes_encode.substring(0,1)
                if (member_card == 1) {
                    member_card = true
                } else {
                    member_card = false
                }
            }

            const new_invoice_date = String(parseInt(invoice_date.substring(0,3)) + 1911) + invoice_date.substring(3, 7) + "000101"

            self.invoice_number = invoice_number

            console.log(invoice_number)


            // if (/^[A-Z]{2}[0-9]{8}$/.test(invoice_number) || /^[0]{10}$/.test(invoice_number)) {
            // For the discount printer use, we do not check the number at the mobile
            if (/^[A-Z0-9]{10}$/.test(invoice_number) || /^[0]{10}$/.test(invoice_number)) {
                console.log('invoice_number test ok')
                if (/^[0]{10}$/.test(invoice_number)) {
                    invoice_number = pos_info
                }
                self.$ga.event('webaps', 'send', '掃描發票成功')
                self.scan_hint = ""
                self.showScanResult = true
                self.$root.loading = true
                self.$http.post('https://' + process.env.VUE_APP_API_URL + '/discount?token=cmtB2GJTr4VOq3raei2y&lot_code=' + self.lot_code, {
                    "license_plate": self.plate,
                    "device_id": "IKEA-CUSTOMER-PHONE",
                    "receipts": [
                        {
                            "receipt_number": invoice_number, 
                            "seller_tax_code": invoice_sell_tax_number, 
                            "consumption_time": new_invoice_date, 
                            "amount": invoice_total_sell_price,
                            "random": invoice_random,
                            "credit_card": credit_card,
                            "pos_info": pos_info,
                            "member_card": member_card
                        }
                    ]
                })
                .then((response) => {
                    self.$root.loading = false
                    if (response.body.results[0].status == 1) {
                        self.discount_description = response.body.results[0].description
                        self.invoice_records = response.body.success_recorded_receipt_list
                        self.$ga.event('webaps', 'send', '掃描正確發票')
                        $("#invoice-success-modal").modal("show")
                    } else if (response.body.results[0].status === 2) {
                        $("#invoice-already-modal").modal("show")
                    } else {
                        $("#invoice-error-modal").modal("show")
                        self.$ga.event('webaps', 'send', '掃描錯誤發票')
                    }
                })
                .catch((response) => {
                    self.recording = false
                })
                .finally(() => {
                    self.recording = false
                });
            }
        } else {
            console.log('invoice_number test failed')
            self.scan_hint = ""
            self.recording = false
        }
    },
    async onInit (promise) {
        var self = this
        self.$root.loading = true
        try {
            await promise
        } catch (error) {
            self.checkBrowser()
            /*if (error.name === 'NotAllowedError') {
                alert('NotAllowedError')
                // user denied camera access permisson
            } else if (error.name === 'NotFoundError') {
                alert('NotFoundError')
                // no suitable camera device installed
            } else if (error.name === 'NotSupportedError') {
                alert('NotSupportedError')
                // page is not served over HTTPS (or localhost)
            } else if (error.name === 'NotReadableError') {
                alert('NotReadableError')
                // maybe camera is already in use
            } else if (error.name === 'OverconstrainedError') {
                alert('OverconstrainedError')
                // passed constraints don't match any camera.
                // Did you requested the front camera although there is none?
            } else if (error.name === 'StreamApiNotSupportedError') {
                alert('StreamApiNotSupportedError')
                // browser seems to be lacking features
            }*/
        } finally {
            self.$root.loading = false
        }
    },
    checkBrowser() {
        var self = this
        self.$ga.event('webaps', 'send', '無法開啟鏡頭')
        if(navigator.userAgent.indexOf("iPhone") >= 0){
            self.android = false
            self.safari = true
        }
        if (navigator.userAgent.indexOf("Android") >= 0) {
            self.android = true
            self.safari = false
        }
    },
    keepScan() {
        var self = this
        self.$ga.event('webaps', 'click', '繼續掃描')
        $("#invoice-error-modal").modal("hide")
        $("#invoice-success-modal").modal("hide")
        self.showScanResult = false
        self.recording = true
    },
    showPayView() {
        var self = this
        self.$ga.event('webaps', 'click', '顯示折抵紀錄')
        if (self.$parent.mode) {
            self.$parent.getDiscount()
            self.$parent.getParkingRecords().then(function() {
                self.$parent.mode = 'pay'
            })
        }
    },
    initScanner() {
        var self = this
        self.recording = true
        if (process.env.VUE_APP_BRAND == 'rtmart') {
             ScanditSDK.configure("AV7OlIiBHCEAO8A7TgBMY2kQyTwrDPoA1HR7Mg5B1PYOeYiRhRrsyW5nd0yWCFOs9ypdtUp04BqrEd/xFWwctad9d1kmM28KHXG4F6UOq5PQc6ya2WOTbp5SXReydD8aqA+IOioHqoETEDOc9N9iywzNtlF8Lirzgv6NTCVBqqAw/TlfYMkD7MzVci9I6b0wZPbJB7r+wmos+YTSslvCrXjM5UHdSQ5ujchikpO8TO6N32OpPcY2iNVB4skxK/KDWtEaHwyWVbNli6hS9zHiFmzjt79xE5kTt9LCAn8VH3bm6DmDcJNKe9pfSTnfvP0RJBVQpJ9LeDUl2SCKHBfDIOyKl6aVHoTIsefglRd2WNGfxgbALZLk9L8s27YNuy05mZERbfhRjFzrPLdYOSXl/IlUqOhxpQiW2xMTN3VV8C4BtrRUFlwwNVisuXlW4ZbJJ8YbKJ94rc3Ty4GTzNnmYC6503Pild5uLm1VYF749Eio+zclD8/PQFlJGWPnVAu4JMRzpaPefExSCjHAbXzoaiXZxMHmmN0DsFmvYQY5YWGGjj50u00ehL8OvhLec0+0raJENT+CbAODXmuZPke3XgEm8jijN38/KKfFTvea4asQ580FI7b6EJ4G4AeupcgpWpwfdUKUmvS9y0UHBNuJWKQI2g/BjO9qKyIc9vZz+6av4O9hgeoHA6D/X7Z73fK/VXXGL113pzuVqjBRSYCIHcnlwYxud+U/ha9KzZHKhTRyMvunpUj6CzUFzo1TGeKpf2HApHGXjAxPR+7mohjc3Ym51lBsnz8Hy2lSPlte/5zyG541aNwlIlPzhg==", {
                engineLocation: "build/"
            })
        } else if (process.env.VUE_APP_BRAND == 'ikea-taoyuan') {
             ScanditSDK.configure("AcN+Q6yBOL7AKEDqdCt2kFZAlsxfPT4wV1y4tgtMoTmEXZLVrSvkvJJyS/y1bpVVSVoav4AN3lUOTy6qEkMhzM8ISnQERJdxjTLY96x89kIMdXxkoHsKpuBZyi+cSByosBhAJzMuM/LHCreshUKKnSiYWlZFvXLuD4XN9e21oTS85xK6CPYdsbmduYAtcfgTFFoC0uYh+uyfQcTe2///fIyWr0dkHTqWhinhDJXmHi20i85BpcfiYQcHt7+4lIZ5EO+eM1OgdIQ7S4fMEzGjlS0TNGIAQtXIPLft23Rq1XHJd3JL6dua6PuXL1khQP6qEUjf7tWI3iC9iRCAWKzRsZ02VjiYN779inMb9PAe4IBO2ahwqxdCULOIA6/EkgPyaeTNMJReu/zhmicMZUnXqflXr1KjqexDvV9BOcdhQUMpKwbyOHMYhtozLoRbbRCPQ1LxvmEMxlbDNR7R4NPvYD2kQY0vTPM1nPTbdLf7a4utCWmsxJJV7jbTtCmPKhOTbXBUHntQk3vQEhwfHtU784yjKkrcmkmGYFUef3j2U9TVt7eYrew8e5b4QwZwrXhVgzhiA7xa485bBOSz3rJ5h9g++Ym1Sfq8nVYo5n6VXwaUgK+ueIfaIvKDbvcOBzBio7QaKMBHbCiJriT0lSvkaYWeUcIj5RFHzacmXiipQwjJ2u+rMG7MVmtRNKggrf9I0dkhtXDXG0DETfrXI68LiFYa5Lo4wSoJr3p4+hmXAKzIO4DiXr6DCNpw8HzFChCPyPMxiOtiyOTjg0e//cJvWuMQ88F6evtVn+OFl2g652kTh+16JrJmbbHNCg73Sg==", {
                engineLocation: "build/"
            })
        } else {
            ScanditSDK.configure("Aav9sKWBMWZ0RcSaRxOFR4Iqsr5XAvZFBlDJqHxSBkD7U70RJzP+7QVCPNH2dMHKo3VWMwBKGCq5XyhL4k3aQlozvwCTalCXVy3evekmDnsGZrbUIXWrb0FxG7+zcUNgQzdjVHsaa4stF52xdtHXDEEp0GJD1VzY/DU/17gFIon/BIElBH5hVbiWhz+AXZdsz0KXoXM3CiloJNHCm1+o8+G35zUVXN55D8mKDaUl7qmYZu8MKfAkKEQIrLKd38DKl+4QPQ76N+rlTHUk7L07H4LScJM0GrvzZ9v8a5efAyRGGKvUOSaN6mgcR4aFPbzO2Sne9KtVlbh4zfvx9jQyxzTFz0fHUJYpnGdjmVam3XO/FYEEsHM/3xZL0QlIzwPYKLdlt+74zzdtO0ug6bbYPzuHJHevhDfZ2sztttZ19SMQP+ItE8Pwxr/i3pehYYcleZcM/iCQZ3uKa2CoK4b2axonZXhKZ05ETjoX+WxofTpEJzTojBR2J4ywSmNkmhwW/GieW5iaXxxsoCvvO068DOLPBzsvdnwruIBvI0KbHvyvHtai9OqvEoMFMgOXNlpjppTZhpkX2tYD+RRcD1ttnB9OtuOJMfdYew2y7luwa4gkPCxKlYFPudlKaRpilnh/7S5NB8wi3wUi2J2p6LARH++E1JYdrLZ/gP3XrEoz4zbX5l4KP7htJlXZJQJ0odYXYa8U9vt8m2bq5BuE9oSPei8VByn8ZG5HdqqmDFsk++E3+zv3+ggCZeg2SLmG755NNEeRgIW+9xHSLG+3o0jniWJx292PElFSATBKA2DxH93avgS464UvoJR18A==", {
                engineLocation: "build/"
            })
        }
        ScanditSDK.BarcodePicker.create(document.getElementById("scandit-barcode-picker"), {
            playSoundOnScan: true,
            vibrateOnScan: true
        }).then(function(barcodePicker) {
            var scanSettings = new ScanditSDK.ScanSettings({
            enabledSymbologies: ["qr"],
                codeDuplicateFilter: 1000
            });
            barcodePicker.applyScanSettings(scanSettings);
            barcodePicker.onScan(function(scanResult) {
                if (scanResult.barcodes[0].data && self.recording){
                    console.log(scanResult.barcodes[0].data)
                    self.recording = false
                    self.onDecode(scanResult.barcodes[0].data)
                }
            });
        });
    }
  }
}
</script>